import React from "react";
import Form from "@Components/Form";
import { ATTENDANCE_URL, URLS } from "configs/constants";

const initialValues = {
  status: "",
  remarks_id: "",
  remarks_reason: "",
  mobile_clock_in_time: "",
  mobile_clock_out_time: "",
  server_clock_in_time: "",
  server_clock_out_time: "",
};

const AttendanceViewDetails = () => {
  const formFields = [
    {
      type: "title",
      title: "Worker",
    },
    {
      type: "renderonly",
      label: "Worker ID",
      key: "employee_id",
    },
    {
      type: "renderonly",
      label: "Worker",
      key: "name",
    },
    {
      type: "renderonly",
      label: "Mobile No.",
      key: "mobile_number",
    },
    {
      type: "renderonly",
      label: "Supervisor",
      key: "supervisor",
    },
    {
      type: "renderonly",
      label: "Company",
      key: "company",
    },
    {
      type: "renderonly",
      label: "Zone",
      key: "zone",
    },
    {
      type: "renderonly",
      label: "Region",
      key: "region",
    },
    {
      type: "renderonly",
      label: "Estate",
      key: "estate",
    },
    {
      type: "renderonly",
      label: "Division",
      key: "division",
    },
    {
      type: "renderonly",
      label: "Block",
      key: "block",
    },

    {
      type: "title",
      title: "Attendance",
    },
    {
      type: "renderonly",
      label: "Date",
      date: true,
      key: "attendance_date",
    },
    {
      type: "renderonly",
      label: "Server Clock In Time",
      key: "server_clock_in_time",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 3 },
    },
    {
      type: "renderonly",
      label: "Server Clock Out Time",
      key: "server_clock_out_time",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_clock_in_time",
      key: "mobile_clock_in_time",
      label: "Mobile Clock In",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_clock_out_time",
      key: "mobile_clock_out_time",
      label: "Mobile Clock Out",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 3 },
    },
    {
      name: "status",
      key: "status",
      label: "Status",
      type: "renderonly",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 3 },
    },
    {
      name: "remarks_id",
      key: "remarks_id",
      label: "Type of Attendance",
      type: "renderonly",
      gridSize: { xs: 12, sm: 8, md: 9, lg: 3 },
    },
    {
      name: "remarks_reason",
      label: "Others-Please Specify",
      type: "input",
      renderKey: "remarks_id",
      renderValue: 20000,
      required: true,
    },
  ];
  const formButtons = ["cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={ATTENDANCE_URL}
      formFields={formFields}
      listRoute={URLS.ATTENDANCE_LIST}
      formButtons={formButtons}
      formTitle="Attendance View Details"
    />
  );
};

export default AttendanceViewDetails;
